import classNames from 'classnames';
import { AmountWithUnit } from 'components/shared/Amount/Amount';
import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';
import styled from 'styled-components';

export interface UnallocatedAmountProps {
  amount: number;
  currency: string;
  hasWarning: boolean;
  isDisabled?: boolean;
  className?: string;
  tabIndex?: number;
}

export const UnallocatedAmount: FC<UnallocatedAmountProps> = ({
  amount,
  currency,
  hasWarning,
  isDisabled,
  className,
  tabIndex,
}) => (
  <>
    <div className={classNames('form-group row  small', className)}>
      <div className="d-flex align-items-center">
        <AmountWithUnit
          unit={currency}
          value={amount}
          isReadOnly
          e2e="dealSplit-unallocatedAmount"
          id="dealSplit-unallocatedAmout"
          isDisabled={isDisabled}
          tabIndex={tabIndex}
          className="text-end box-shadow-none"
        />{' '}
        <label htmlFor="dealSplit-unallocatedAmount" className="col-form-label ps-1">
          <span>
            <FormattedMessage id="form.DealSplit.unallocatedAmount" />
          </span>
        </label>
      </div>
      {hasWarning && !isDisabled && (
        <span className="text-warning">
          <FormattedMessage id="form.DealSplit.warning.unallocatedAmount" />
        </span>
      )}
    </div>
  </>
);

export const MaxSizedUnallocatedAmount = styled(UnallocatedAmount)`
  max-width: 12rem;
`;
